import loadable from '@loadable/component';

export default loadable(() =>
  import(/* webpackChunkName: "AuthModals" */ './containers/AuthModal'),
);
